import { Controller } from 'stimulus';

class FileUploadController extends Controller {
  onInputChange(e) {
    const fileName = e.target.value.split('\\').pop();

    if (fileName) {
      this.labelTarget.innerText = fileName;
    }
  }
}

FileUploadController.targets = [
  'label',
];

export default FileUploadController;
